{
  "zh-CN": {
    "datetime": {
      "formats": {
        "default": "d MMMM y 'at' HH:mm z",
        "short": "d MMM HH:mm z",
        "iso": "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"
      }
    }
  }
}
